import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KeyboardService } from '@geneplanet/ngx-shop/src/lib/shared';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-bottom-offset',
  templateUrl: './bottom-offset.component.html',
  styleUrls: ['./bottom-offset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomOffsetComponent {
  @Input() type: string;

  public keyboardActive$: BehaviorSubject<boolean>;

  constructor(private readonly keyboardService: KeyboardService) {
    this.keyboardActive$ = this.keyboardService.keyboardActive$;
  }
}
